import { render, staticRenderFns } from "./DmsUsersFormActions.vue?vue&type=template&id=1f632132"
import script from "./DmsUsersFormActions.vue?vue&type=script&lang=js"
export * from "./DmsUsersFormActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports